import { _hostMediaUrl } from "../redux/api";
import {PersonGray} from "../image";

export function generateMediaUrl (path) {
    if (path?.startsWith('http')) {
        return path;
    }

    return path && path !== 'None' ? `${_hostMediaUrl}/${path}` : PersonGray;
}

export function generateVideoUrl (path) {
    if (path?.startsWith('http')) {
        return path;
    }

    return path && path !== 'None' && `${_hostMediaUrl}/${path}`;
}
